import { paymentsApi } from '.';

export interface GocardlessExecuteData {
  subscriptionId: string,
}

export interface GocardlessExecuteRequest {
  firstName: string,
  lastName: string,
  email: string,
  address1: string,
  address2: string,
  address3: string,
  town: string,
  postcode: string,
  country: string,
  amount: number,
  currency: string,
  giftaid: number,
  order_reference: string,
  accountHolderName: string,
  accountNumber: string,
  billingDayOfMonth: string,
  sortCode: string,
  affiliate: null,
  campaign: string,
  client: string,
  cartId: string,
  transSource: string,
  transSourceUrl: string,
  transType: string,
  metadata?: string,
}

export interface GocardlessExecuteResponse {
  data: GocardlessExecuteData,
  message: string,
}

const extendedPaymentsApi = paymentsApi.injectEndpoints({
  endpoints: builder => ({
    gocardlessExecute: builder.mutation<GocardlessExecuteResponse, GocardlessExecuteRequest>({
      query: body => ({
        url: 'provider/go-cardless/execute',
        method: 'POST',
        body,
      })
    })
  })
});

export const { useGocardlessExecuteMutation } = extendedPaymentsApi;
